import styles from "./userInfo.module.css";
import React from "react";
import { calculateAge, noDataLabel } from "../../utils/constants";
import { IUserReport } from "../../services/types/users.types";
import { tWithKeyAttr as t } from "../../i18nHelper";


function UserInfo({
  user,
  customClassName,
}: {
  user: IUserReport;
  customClassName?: string;
}) {
  return (
    <section className={`${styles.userSection} ${customClassName}`}>
      <article className={styles.user}>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('USERNAME')}</p>
          <p className={styles.user__text}>
            {`${user.Users.FirstName} ${user.Users.LastName || ""}`}
          </p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('USER_ID')}</p>
          <p className={styles.user__text}>{user.Users.Id}</p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('AGE')}</p>
          <p className={styles.user__text}>
            {user.Users.Birth ? calculateAge(user.Users.Birth) : t('NO_INFORMATION')}
          </p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>
            {t('MOBILE')}</p>
          <p className={styles.user__text}>
            {user?.Users.Phone || (t(noDataLabel))}
          </p>
        </div>
        <div>
          <p className={`${styles.user__label} ${styles.form__subtitle}`}>{t('EMAIL')}</p>
          <p className={styles.user__text}>
            {user?.Users.Email || t(noDataLabel)}
          </p>
        </div>
      </article>
    </section>
  );
}

export default UserInfo;
